import React from 'react';
import { SearchFilter } from '../SearchFilter/SearchFilter';
import { SearchResults } from '../SearchResults/SearchResults';
import { CategoryComponents } from '@app/components/header/components/HeaderSearch/HeaderSearch';
import { CategoryType } from '@app/constants/categoriesList';
import { NotFound } from '@app/components/common/NotFound/NotFound';
import * as S from './SearchOverlay.styles';

interface SearchOverlayProps {
  data: CategoryComponents[] | null;
  isFilterOpen: boolean;
  selectedCategories: CategoryType[];
  onCategoryChange: (cats: CategoryType[]) => void;
}

export const SearchOverlay: React.FC<SearchOverlayProps> = ({
  data,
  isFilterOpen,
  selectedCategories,
  onCategoryChange,
}) => {
  return (
    <S.Menu>
      <SearchFilter
        data={data}
        isOpen={isFilterOpen}
        selectedCategories={selectedCategories}
        onCategoryChange={onCategoryChange}
      >
        {(filteredResults) =>
          filteredResults.length > 0 ? <SearchResults results={filteredResults} /> : data !== null ? <NotFound /> : null
        }
      </SearchFilter>
    </S.Menu>
  );
};
